import { useCallback, useState } from "react";
import { getSingleUserReport } from "../service/ReportingService";


export default function useUserReport() {
  const [data, setData] = useState(null);
  const [groupOptions, setGroupOptions] = useState([]);
  const [error, setError] = useState(null);

  const fetchUserReport = useCallback(async (id) => {
    setError(null);
    try {
      const userData = await getSingleUserReport(id);
      setData({
        ...userData,
        enrollments: userData?.enrollments || [],
      });

      const groupSet = new Set();
      userData?.enrollments?.forEach((e) => {
        if (e.groupName && e.groupName !== "null") groupSet.add(e.groupName);
      });
      setGroupOptions([...groupSet]);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  return { data, setData, groupOptions, error, fetchUserReport };
}